// extracted by mini-css-extract-plugin
export default {"thumb":"FormFieldImageUploadWrapper_thumb__-Pf9E"};